import Vue from 'vue'
import * as Sentry from "@sentry/vue";
import './test-utils'; // Load test utilities for development/testing
import { buildEncounterDetails } from '@/utils/encounterDetails';

Sentry.init({
    Vue: Vue,
    dsn: process.env.VUE_APP_SENTRY_DSN,
    environment: window.thinkmd.env || 'local',
    release: 'flexi@' + (process.env.VUE_APP_GIT_HASH || 'dev'),
    attachProps: true,
    logErrors: true,
    sampleRate: window.location.hostname === 'localhost' ? 0 : 1.0,
    tracesSampleRate: window.location.hostname === 'localhost' ? 0 : 1.0,
    transport: Sentry.makeBrowserOfflineTransport(Sentry.makeFetchTransport),
    transportOptions: {
      maxQueueSize: 1000,
    },
    // disable auto session tracking
    // this creates a lot of events for offline queues
    // basically every page load is tracked.
    // do we want this, or do we just want to track crashes?
    autoSessionTracking: false,
    beforeSend: (event, hint) => {
        if (window.location.hostname === 'localhost') {
            // do not send events in development
            console.error(hint.originalException || hint.syntheticException || event);
            return null;
        }
        try {
            let details = buildEncounterDetails()
            event.tags = event.tags || {}
            event.extra = {}
            event.user = details.user
            event.tags['code'] = details.encounter.code
            event.tags['experience'] = details.encounter.experience
            event.tags['language'] = details.encounter.language
            event.tags['network'] = details.encounter.network
            event.tags['app'] = details.release.name
            event.tags['commit'] = details.release.commit
            event.extra['track'] = details.track
        } catch (e) {
          // do nothing
        }

        return event
    }
})

Vue.prototype.$sentry = Sentry
